import {CloseCircleOutlined, SortAscendingOutlined} from '@ant-design/icons';
import {BottomSheet, Button, Chip, Radio} from '@ds/components';
import {useState} from 'react';

import {
  CUSTOM_DEAL_BADGE_OPTIONS,
  CUSTOM_DEAL_SORT_OPTIONS,
  CUSTOM_DEAL_STOCK_STATUS_OPTIONS
} from '../../../constants';

type SelectProductsFiltersProps = {
  filters: Record<string, string | number | boolean | null | undefined>;
  onChangeFilter: (name: string, value: string | null) => void;
};

const SelectProductsFilters: React.FC<SelectProductsFiltersProps> = ({filters, onChangeFilter}) => {
  const [activeFilter, setActiveFilter] = useState<string | null>(null);
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  const openModal = (name: string) => {
    setActiveFilter(name);
    setSelectedValue(filters?.[name] != null ? String(filters[name]) : null);
  };

  const closeModal = () => {
    setActiveFilter(null);
    setSelectedValue(null);
  };

  const currentOptions =
    activeFilter === 'badge'
      ? CUSTOM_DEAL_BADGE_OPTIONS
      : activeFilter === 'sort'
        ? CUSTOM_DEAL_SORT_OPTIONS
        : activeFilter === 'stock_status'
          ? CUSTOM_DEAL_STOCK_STATUS_OPTIONS
          : [];

  const currentTitle =
    activeFilter === 'badge' ? 'فروش' : activeFilter === 'sort' ? 'مرتب‌سازی' : 'موجودی';

  const renderButton = (name: string, label: string, icon?: React.ReactNode) => {
    const hasValue = filters?.[name] !== null && filters?.[name] !== undefined;

    return (
      <Chip
        key={name}
        label={label}
        icon={icon}
        selected={hasValue}
        suffix={
          hasValue ? (
            <CloseCircleOutlined
              className="text-body-lg"
              onClick={(event) => {
                event.stopPropagation();
                onChangeFilter(name, null);
              }}
            />
          ) : undefined
        }
        onClick={() => openModal(name)}
      />
    );
  };

  return (
    <>
      <div className="flex min-h-12 overflow-x-auto border-b border-gray-02 px-4 py-2 scrollbar-none">
        <div className="flex w-max items-center gap-2">
          {renderButton('sort', 'مرتب‌سازی', <SortAscendingOutlined aria-hidden />)}
          {renderButton('badge', 'فروش')}
          {renderButton('stock_status', 'موجودی')}
        </div>
      </div>
      <BottomSheet
        show={Boolean(activeFilter)}
        onClose={closeModal}
        header={
          <div className="flex flex-col items-center px-4 py-2 text-subtitle-md text-neutral-fg">
            <span className="mb-4 h-1 w-8 rounded-full bg-gray-03" aria-hidden />
            <span>{currentTitle}</span>
          </div>
        }
      >
        <Radio.Group
          className="w-full"
          value={selectedValue ?? undefined}
          onChange={(event) => setSelectedValue(String(event.target.value))}
        >
          <div className="flex flex-col px-4 py-2">
            {currentOptions.map((option) => (
              <Radio
                key={String(option.value)}
                value={String(option.value)}
                className="w-full border-b border-gray-22 py-4"
              >
                {option.label}
              </Radio>
            ))}
          </div>
        </Radio.Group>
        <div className="mt-2 flex flex-col gap-2 px-4 py-3">
          <Button
            fullWidth
            size="lg"
            onClick={() => {
              onChangeFilter(activeFilter as string, selectedValue);
              closeModal();
            }}
          >
            تایید
          </Button>
          <Button variant="ghost" size="lg" fullWidth onClick={closeModal}>
            بستن
          </Button>
        </div>
      </BottomSheet>
    </>
  );
};

export default SelectProductsFilters;
